export function normalizeQuantity(q) {
  return {
    id: q.id,
    nodeId: `q${q.id}`,
    code: q.code,
    title: q.title,
    goldType: q.gold_type,
    hasMapping: q.has_mapping,
    mappingSourceName: q.mapping_source_name || null,
    isDirect: q.is_direct || false,
    type: q.type,
    conversionFactor: q.conversion_factor,
    commissionUnit: q.commission_unit,
    commissionStepValue: q.commission_step_value ?? null,
    buyCommission: q.buy_commission,
    sellCommission: q.sell_commission,
    type: q.is_direct ? 'direct' : 'quantity',
    showPrice: q.show_price ?? false,
    prices: {
      buy: {
        'price': q?.buy_price?.price || null,
        'basePrice': q?.buy_price?.base_price || null,

      },
      sell: {
        'price': q?.sell_price?.price || null,
        'basePrice': q?.sell_price?.base_price || null,
      }
    },

    active: {
      buy: {
        'isActive': q?.buy_price_is_active?.is_active,
        'id': q?.buy_price_is_active?.id
      },
      sell: {
        'isActive': q?.sell_price_is_active?.is_active,
        'id': q?.sell_price_is_active?.id
      }
    },

    steps: {
      buy: {
        'value': q?.buy_step?.value || null,
        'scope': q?.buy_step?.scope || null,

      } ,
      sell: {
        'value': q?.sell_step?.value || null,
        'scope': q?.sell_step?.scope || null,
      } ,
    },

    isActive: q.is_active
  }
}
